<div class="host-system-notification-dynamic">
  <div class="n-container">
    <div class="n-top">
      @if (notification.has_icon) {
        <div class="n-icon mr-[15px]">
          <i nz-icon nzType="info-circle" nzTheme="outline" class="info-icon"></i>
        </div>
      }
      <div class="n-title">
        {{ notification?.title }}
      </div>
    </div>
    <div
      class="n-body mt-[20px]"
      [ngClass]="{
        'ml-[0]': !notification.has_icon,
        'ml-[50px]': notification.has_icon
      }">
      <div class="n-content" [innerHTML]="notification?.content"></div>
      <div class="n-footer" *ngIf="notification?.has_button">
        <button nz-button nzType="primary" (click)="onClickBtn()">{{ notification?.button_title }}</button>
      </div>
    </div>
  </div>
</div>
